import { UserSettings } from 'src/types/UserSettings.ts';
import { PropsWithChildren, useContext } from 'react';
import { getProductUrl } from 'src/utils/getProductUrl';
import { ConfigContext } from 'src/configContext.ts';

type Props = PropsWithChildren<{
    userSettings: UserSettings;
    code: string;
    content: string;
}>

export const ViewProductLink = ({ userSettings, code, content, children }: Props) => {
    const { uri } = useContext(ConfigContext);
    const productUrl = getProductUrl({
        countryDomain: userSettings.countryDomain,
        currentLocale: userSettings.currentLocale,
        label: code,
    });
    let href = productUrl;
    if (content.length > 0) {
        const url = new URL(`${uri}/design-data`);
        url.searchParams.set('url', productUrl);
        url.searchParams.set('content', content);
        href = url.toString();
    }
    return (
        <a
            href={href}
            className="vss-device__product-link"
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
        >{children}
        </a>
    );
};
